module.exports = __webpack_public_path__ + "static/media/1 dove dagger tattoo sleeve black and grey .1280x1707.d0c9d009.webp";